// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TPublicWebV1SearchRequest, TPublicWebV1SearchModel, IMappers, TPublicWebV1SearchResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicWebV1SearchResponse } from '../../../entities/response/PublicWebV1SearchResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicWebV1SearchModel(parameters: TPublicWebV1SearchRequest): TPublicWebV1SearchModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/web/v1/search/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicWebV1SearchOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicWebV1SearchRequest;
}

export async function fetchPublicWebV1Search<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicWebV1SearchOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicWebV1SearchResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicWebV1SearchModel(parameters),
    config,
  )) as FetchResponse<TPublicWebV1SearchResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicWebV1SearchResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicWebV1SearchResponse>;
}
